export const SET_MESSAGES_REDUCER: string = "SET_MESSAGES_REDUCER";
export const CLEAR_MESSAGES_REDUCER: string = "CLEAR_MESSAGES_REDUCER";
